import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { FaWhatsapp } from 'react-icons/fa';
import PhoneAuthForm from '../PhoneAuthForm';
import OtpVerification from '../OtpVerification';
import { Container, WhatsAppButton, FlowContainer } from './styles';

type Step = 'phone' | 'otp' | 'register';

interface IWhatsAppLoginFlowProps {
  onSuccess?: () => void;
}

const WhatsAppLoginFlow: React.FC<IWhatsAppLoginFlowProps> = ({ onSuccess }) => {
  const [currentStep, setCurrentStep] = useState<Step>('phone');
  const [phone, setPhone] = useState('');
  const [isExpanded, setIsExpanded] = useState(false);
  const history = useHistory();

  const handlePhoneSubmitted = (phoneNumber: string) => {
    setPhone(phoneNumber);
    setCurrentStep('otp');
  };

  const handleOtpSuccess = () => {
    if (onSuccess) {
      onSuccess();
    } else {
      history.push('/');
    }
  };

  const handleNeedsRegistration = (phoneNumber: string) => {
    history.push('/complete-registration', {
      phone: phoneNumber,
      requiresPhoneCompletion: true,
      type: 'tenant'
    });
  };

  const handleToggleFlow = () => {
    setIsExpanded(!isExpanded);
    if (isExpanded) {
      setCurrentStep('phone');
      setPhone('');
    }
  };

  if (!isExpanded) {
    return (
      <Container>
        <WhatsAppButton onClick={handleToggleFlow}>
          <FaWhatsapp />
          <span>Entrar com WhatsApp</span>
        </WhatsAppButton>
      </Container>
    );
  }

  return (
    <Container>
      <FlowContainer>
        {currentStep === 'phone' && (
          <>
            <PhoneAuthForm onPhoneSubmitted={handlePhoneSubmitted} showSocialButtons={false} />
          </>
        )}

        {currentStep === 'otp' && (
          <OtpVerification
            phone={phone}
            onSuccess={handleOtpSuccess}
            onNeedsRegistration={handleNeedsRegistration}
          />
        )}
      </FlowContainer>
    </Container>
  );
};

export default WhatsAppLoginFlow;
